// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Drag = ({ size, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <line x1='19' y1='24' x2='29' y2='24' />
      <line x1='19' y1='4' x2='29' y2='4' />
      <line x1='19' y1='44' x2='29' y2='44' />
    </svg>
  );
};
